import { RouteLocationNormalizedGeneric } from 'vue-router';
import { UserStoreInstance } from '/@stores/user';
import { Modules } from '/@types/ids';

export type RouterGate = 'timer' | 'ressurs';

declare module 'vue-router' {
  interface RouteMeta {
    requiresAuth?: boolean;
    gate?: RouterGate;
  }
}

export function gateRedirect(to: RouteLocationNormalizedGeneric, userStore: UserStoreInstance) {
  const gate = to.meta.gate;
  if (!gate) return null;

  if (gate === 'timer') {
    return userStore.hasModule(Modules.Timer) || '/resources/events';
  }

  if (gate === 'ressurs') {
    return userStore.hasModule(Modules.Ressurs) || '/timer/week';
  }

  return null;
}
